import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const WishketSymbol = ({ className, variant })=>{
    if (variant === 'disabled') {
        return /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--wishket-symbol-disabled",
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.7187 9.45926L14.9588 11.604L14.9094 12L10.2935 14.6912L10.2948 19.6569C10.2948 20.2047 10.9375 20.7125 10.9375 20.7125C11.5948 21.0957 12.4041 21.0957 13.0614 20.7125L18.9374 17.2846C19.5947 16.9014 20.0001 16.1943 20.0001 15.4266V8.57335C20.0001 8.31876 19.9521 8.07446 19.8694 7.84302C19.6707 8.90766 19.1641 9.16096 18.7187 9.45926Z",
                    fill: "#BDBDBD"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5454 19.6262V9.18422L6.66673 6.82607C5.95473 6.29118 5.0614 6.71421 5.0614 6.71421C4.73408 6.91009 4.46452 7.18389 4.27865 7.50928C4.09278 7.83467 3.99685 8.2007 4.00008 8.57218V15.428C4.00008 16.1944 4.40408 16.9028 5.0614 17.286L10.9387 20.7127C11.116 20.8168 11.3067 20.8901 11.5014 20.9377C11.2198 20.843 10.9761 20.6655 10.8046 20.4302C10.6331 20.195 10.5424 19.9137 10.5454 19.6262Z",
                    fill: "#D1D1D1"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.19066 6.91461L14.9093 11.9999L19.2652 9.4592C19.7906 9.15318 20.0372 8.53857 19.9119 7.96768C19.7636 7.44607 19.4158 6.99807 18.9386 6.71402L13.0613 3.28738C12.7413 3.09942 12.3739 3 11.9993 3C11.6246 3 11.2572 3.09942 10.9373 3.28738L5.06133 6.71402C4.88495 6.8182 4.72508 6.94639 4.58667 7.09462C4.79532 6.89753 5.06597 6.77289 5.35608 6.74031C5.64618 6.70772 5.94062 6.76904 6.19066 6.91461Z",
                    fill: "#E0E0E0"
                })
            ]
        });
    }
    if (variant === 'bluegray') {
        return /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--wishket-symbol-bluegray",
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.7187 9.45926L14.9588 11.604L14.9094 12L10.2935 14.6912L10.2948 19.6569C10.2948 20.2047 10.9375 20.7125 10.9375 20.7125C11.5948 21.0957 12.4041 21.0957 13.0614 20.7125L18.9374 17.2846C19.5947 16.9014 20.0001 16.1943 20.0001 15.4266V8.57335C20.0001 8.31876 19.9521 8.07446 19.8694 7.84302C19.6707 8.90766 19.1641 9.16096 18.7187 9.45926Z",
                    fill: "#4D525C"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5454 19.6262V9.18422L6.66673 6.82607C5.95473 6.29118 5.0614 6.71421 5.0614 6.71421C4.73408 6.91009 4.46452 7.18389 4.27865 7.50928C4.09278 7.83467 3.99685 8.2007 4.00008 8.57218V15.428C4.00008 16.1944 4.40408 16.9028 5.0614 17.286L10.9387 20.7127C11.116 20.8168 11.3067 20.8901 11.5014 20.9377C11.2198 20.843 10.9761 20.6655 10.8046 20.4302C10.6331 20.195 10.5424 19.9137 10.5454 19.6262Z",
                    fill: "#8C929C"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.19066 6.91461L14.9093 11.9999L19.2652 9.4592C19.7906 9.15318 20.0372 8.53857 19.9119 7.96768C19.7636 7.44607 19.4158 6.99807 18.9386 6.71402L13.0613 3.28738C12.7413 3.09942 12.3739 3 11.9993 3C11.6246 3 11.2572 3.09942 10.9373 3.28738L5.06133 6.71402C4.88495 6.8182 4.72508 6.94639 4.58667 7.09462C4.79532 6.89753 5.06597 6.77289 5.35608 6.74031C5.64618 6.70772 5.94062 6.76904 6.19066 6.91461Z",
                    fill: "#787D85"
                })
            ]
        });
    }
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        "data-testid": "design-system-logo--wishket-symbol",
        children: [
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.7187 9.45926L14.9588 11.604L14.9094 12L10.2935 14.6912L10.2948 19.6569C10.2948 20.2047 10.9375 20.7125 10.9375 20.7125C11.5948 21.0957 12.4041 21.0957 13.0614 20.7125L18.9374 17.2846C19.5947 16.9014 20.0001 16.1943 20.0001 15.4266V8.57335C20.0001 8.31876 19.9521 8.07446 19.8694 7.84302C19.6707 8.90766 19.1641 9.16096 18.7187 9.45926Z",
                fill: "#0055B8"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5454 19.6262V9.18422L6.66673 6.82607C5.95473 6.29118 5.0614 6.71421 5.0614 6.71421C4.73408 6.91009 4.46452 7.18389 4.27865 7.50928C4.09278 7.83467 3.99685 8.2007 4.00008 8.57218V15.428C4.00008 16.1944 4.40408 16.9028 5.0614 17.286L10.9387 20.7127C11.116 20.8168 11.3067 20.8901 11.5014 20.9377C11.2198 20.843 10.9761 20.6655 10.8046 20.4302C10.6331 20.195 10.5424 19.9137 10.5454 19.6262Z",
                fill: "#00A7E1"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.19066 6.91461L14.9093 11.9999L19.2652 9.4592C19.7906 9.15318 20.0372 8.53857 19.9119 7.96768C19.7636 7.44607 19.4158 6.99807 18.9386 6.71402L13.0613 3.28738C12.7413 3.09942 12.3739 3 11.9993 3C11.6246 3 11.2572 3.09942 10.9373 3.28738L5.06133 6.71402C4.88495 6.8182 4.72508 6.94639 4.58667 7.09462C4.79532 6.89753 5.06597 6.77289 5.35608 6.74031C5.64618 6.70772 5.94062 6.76904 6.19066 6.91461Z",
                fill: "#00B551"
            })
        ]
    });
};

export { WishketSymbol as default };
